import Bugsnag from "@bugsnag/js";

export const notifyBugReporter = (message: any) => {
  Bugsnag.notify(message);
};
